import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from './messages';
import { Icon, Wrapper } from './styles';
import { StarRatingProps } from './types';

const StarRating = ({ theme = 'small' }: StarRatingProps) => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper $theme={theme} id="fiveStarWrapper" aria-label={formatMessage(messages.ariaLabel)}>
			<Text el="p" srOnly>
				{formatMessage(messages.ariaLabel)}
			</Text>
			<Icon />
			<Icon />
			<Icon />
			<Icon />
			<Icon />
		</Wrapper>
	);
};

export default StarRating;
